import type { AppLocales } from '@constants/i18n'
import { getCountryLanguageFromLocale } from '@helpers/getCountryLanguageFromLocale'
import type { NavItems } from '@helpers/getFooter'
import { getFullUrlForFeature } from '@helpers/getFullUrlForFeature'

export const getDataFromReadMore = (
  locale: AppLocales,
  readMoreData?: NavItems['readMore']
) => {
  if (!readMoreData) return undefined

  const { country } = getCountryLanguageFromLocale(locale)
  const countryCode = country?.toUpperCase()

  const { label, readMoreItems, externalLink } = readMoreData
  if (!label) return

  if (externalLink) {
    return {
      label,
      href: externalLink,
    }
  } else if (readMoreItems) {
    const item = readMoreItems.find(item =>
      item?.countryCodes?.includes(countryCode)
    )

    if (item?.slug && item?.type) {
      const fullUrl = getFullUrlForFeature(locale, item.slug, item.type)

      if (fullUrl) {
        return {
          label,
          href: fullUrl,
        }
      }
    }
  }
}
